/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { killswitchesBatchUserBadges } from "../funcs/killswitchesBatchUserBadges.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { KillswitchBatchUserBadgesResult } from "../models/components/killswitchbatchuserbadgesresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  KillswitchesBatchUserBadgesRequest,
  KillswitchesBatchUserBadgesSecurity,
} from "../models/operations/killswitchesbatchuserbadges.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type BatchKillswitchUserBadgesMutationVariables = {
  security: KillswitchesBatchUserBadgesSecurity;
  request: KillswitchesBatchUserBadgesRequest;
  options?: RequestOptions;
};

export type BatchKillswitchUserBadgesMutationData =
  KillswitchBatchUserBadgesResult;

export type BatchKillswitchUserBadgesMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * batchUserBadges killswitches
 */
export function useBatchKillswitchUserBadgesMutation(
  options?: MutationHookOptions<
    BatchKillswitchUserBadgesMutationData,
    BatchKillswitchUserBadgesMutationError,
    BatchKillswitchUserBadgesMutationVariables
  >,
): UseMutationResult<
  BatchKillswitchUserBadgesMutationData,
  BatchKillswitchUserBadgesMutationError,
  BatchKillswitchUserBadgesMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildBatchKillswitchUserBadgesMutation(client, options),
    ...options,
  });
}

export function mutationKeyBatchKillswitchUserBadges(): MutationKey {
  return ["@gram/client", "killswitches", "batchUserBadges"];
}

export function buildBatchKillswitchUserBadgesMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: BatchKillswitchUserBadgesMutationVariables,
  ) => Promise<BatchKillswitchUserBadgesMutationData>;
} {
  return {
    mutationKey: mutationKeyBatchKillswitchUserBadges(),
    mutationFn: function batchKillswitchUserBadgesMutationFn({
      security,
      request,
      options,
    }): Promise<BatchKillswitchUserBadgesMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(killswitchesBatchUserBadges(
        client$,
        security,
        request,
        mergedOptions,
      ));
    },
  };
}
